import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcTokenService } from '../oidc-token.service';

export const oidcAuthorizationInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(OidcTokenService);

  if (req.url.includes('callback=') ||
      req.url.includes('maps.googleapis.com')) {
    return next(req);
  }

  if (req.url.includes('/oauth2/token')) {
    req = req.clone({ setHeaders: { 'x-skip-error-interceptor': 'true' } });
    return next(req);
  }

  const token = tokenService.getAccessToken();
  if (token) {
    req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }
  return next(req);
};
